import { render } from "./AllInclusive.vue?vue&type=template&id=f41fc7fe"
import script from "./AllInclusive.vue?vue&type=script&lang=js"
export * from "./AllInclusive.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__